import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-white text-2xl font-semibold" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "border border-divider p-1 text-center text-sm md:text-base" }
const _hoisted_4 = { class: "mb-1 font-bold whitespace-nowrap" }
const _hoisted_5 = { class: "border border-divider p-1" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "card-content-row"
}
const _hoisted_8 = {
  key: 0,
  class: "card-content-row"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "entity-title text-error-dark" }
const _hoisted_11 = { class: "card-content-row" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_13 = { class: "card-content-row" }

import { ref, computed } from "vue";
import { CalendarDayHour, ChineseCalendarAction } from "@/types/calculators";
import DayCardComponent from "@/views/Calculators/ChineseCalendar/components/DayCardComponent.vue";
import { useI18n } from "vue-i18n";

type TimeInterval = { start: number; end: number };


export default /*@__PURE__*/_defineComponent({
  __name: 'DayHoursTableComponent',
  props: {
    hoursTable: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const baseHours: TimeInterval[] = [
  { start: 0, end: 60 }, // 00:00 – 01:00
  { start: 60, end: 180 }, // 01:00 – 03:00
  { start: 180, end: 300 }, // 03:00 – 05:00
  { start: 300, end: 420 }, // 05:00 – 07:00
  { start: 420, end: 540 }, // 07:00 – 09:00
  { start: 540, end: 660 }, // 09:00 – 11:00
  { start: 660, end: 780 }, // 11:00 – 13:00
  { start: 780, end: 900 }, // 13:00 – 15:00
  { start: 900, end: 1020 }, // 15:00 – 17:00
  { start: 1020, end: 1140 }, // 17:00 – 19:00
  { start: 1140, end: 1260 }, // 19:00 – 21:00
  { start: 1260, end: 1380 }, // 21:00 – 23:00
  { start: 1380, end: 1440 }, // 23:00 – 00:00
];

const timeOffset = ref(0);

const formatTime = (totalMinutes: number): string => {
  const normalized = ((totalMinutes % 1440) + 1440) % 1440;
  const h = Math.floor(normalized / 60);
  const m = normalized % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const chineseDoubleHours = computed(() => {
  return baseHours.map((interval: TimeInterval) => {
    const shiftedStart = formatTime(interval.start + timeOffset.value);
    const shiftedEnd = formatTime(interval.end + timeOffset.value);
    return `${shiftedStart} – ${shiftedEnd}`;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DayCardComponent, null, {
    "card-title": _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("calculators.chinese-calendar-day.hours-table.title")), 1)
    ]),
    "card-content": _withCtx(() => [
      _createElementVNode("table", null, [
        _createElementVNode("tbody", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.hoursTable, (tableRow, idx) => {
            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(chineseDoubleHours.value[idx]), 1),
                _createElementVNode("p", null, _toDisplayString(tableRow.hour_element), 1)
              ]),
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                    tableRow.actions.filter((a) => a.is_positive),
                  ], (positiveActions, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: 'positive-' + idx
                    }, [
                      (positiveActions.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.pluses")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(positiveActions
                          .map((a) =>
                            _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
                          )
                          .join(", ")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                    tableRow.actions.filter((a) => !a.is_positive),
                  ], (negativeActions, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: 'negative-' + idx
                    }, [
                      (negativeActions.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.minuses")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(negativeActions
                          .map((a) =>
                            _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
                          )
                          .join(", ")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (tableRow.collisions !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableRow.collisions, (collision, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "my-2",
                            key: 'collision-' + id
                          }, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(collision.name), 1),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(collision.desc), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (tableRow.symbol_stars !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableRow.symbol_stars, (star, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "my-2",
                            key: 'star-' + id
                          }, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["entity-title", {
                        'text-error-dark': !star.is_positive,
                        'text-success': star.is_positive,
                      }])
                            }, _toDisplayString(star.star), 3),
                            _createElementVNode("p", _hoisted_13, _toDisplayString(star.desc), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})